<section class="content-not-found bg-white">
    <div class="content-logo bg-primary">
        <img  src="./assets/img/{{portal}}.svg" alt="icon-{{portal}}" />
    </div>
    <div class="content-text">
        <p class="tile">{{ "not-found.title" | translate }}</p>
        <div class="content-desc">
            <p class="desc">{{ "not-found.desc-1" | translate }}</p>
            <p class="desc">{{ "not-found.desc-2" | translate }}</p>
        </div>
    </div>
</section>
